/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum GuardianshipStatus {
    NO_GUARDIAN_REQUIRED = 'noGuardianRequired',
    UNDER_GUARDIANSHIP = 'underGuardianship',
    IS_GUARDIAN = 'isGuardian',
}
